import React from 'react'
import * as yup from 'yup'

const phoneRegExp = /^\d{5,20}$/
const alphaRegex = /^[a-zA-Z.-]+$/
const nameRegex = /^[a-zA-Z ].+$/
const teamNameRegex = /^[a-zA-Z0-9\s]+$/
const emailRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const uploadFileSchema = {
  employee_addition: ({ entities = [] }) => {
    const entity_name_error = (
      <div>
        Entity name should be one of the following:
        <ol style={{ listStyleType: 'disc', listStylePosition: 'inside', paddingLeft: 10 }}>
          {entities.map(item => <li>{item}</li>)}
        </ol>
      </div>
    )
    return (
      yup.object().shape({
        employee_code: yup.string(),
        first_name: yup.string().matches(nameRegex, 'First name should not contain numbers and special characters (except space)').required('First name is required'),
        last_name: yup.string().matches(nameRegex, 'Last name should not contain numbers and special characters (except space)'),
        email: yup.string().matches(emailRegExp, 'Email is invalid').required('Email is required'),
        employee_office_location: yup.string(),
        date_of_birth: yup.string(),
        gender: yup
          .string()
          .matches(alphaRegex, 'Gender should not contain numbers and special characters')
          .oneOf(['male', 'female', 'non-binary'], 'Gender should be one of [male, female, non-binary]'),
        department: yup.string(),
        mobile_number: yup.string().matches(phoneRegExp, 'The mobile number must be valid and its length should be between 5 to 20 digits.'),
        vip: yup.string().matches(alphaRegex, 'Vip should not contain numbers and special characters').oneOf(['yes', 'no'], 'Vip should be one of [yes, no]'),
        entity_name: entities.length > 0 ? yup.string().oneOf(entities, entity_name_error).required(entity_name_error) : yup.string().oneOf([''], 'No entities present for your company'),
      })
    )
  },

  employee_deactivation: (_) => 
  (
    yup.object().shape({
      email: yup.string().matches(emailRegExp, 'Email ID doesn’t exists').required('Email is required'),
    })
  ),

  family_addition: (_) => 
  (
    yup.object().shape({
      first_name: yup.string().matches(nameRegex, 'First name should not contain numbers and special characters (except space)').required('First name is required'),
      last_name: yup.string().matches(nameRegex, 'Last name should not contain numbers and special characters (except space)'),
      email: yup.string().matches(emailRegExp, 'Invalid email').required('Email is required'),
      date_of_birth: yup.string(),
      gender: yup
        .string()
        .matches(alphaRegex, 'Gender should not contain numbers and special characters')
        .oneOf(['male', 'female', 'non-binary'], 'Gender should be one of [male, female, non-binary]')
        .required('Gender is required'),
      relation: yup.string().matches(nameRegex, 'Relation should not contain numbers and special characters(except space)').oneOf(['father', 'mother', 'father in law', 'mother in law', 'brother', 'sister', 'son', 'daughter', 'wife', 'husband'], 'Relation should be one of [father, mother, father in law, mother in law, brother, sister, son, daughter, wife, husband]').required('Relation is required'),
    })
  ),

  ppmc_bulk_uploader: ({ entities = [] }) => {
    const entity_name_error = (
      <div>
        Entity name should be one of the following:
        <ol style={{ listStyleType: 'disc', listStylePosition: 'inside', paddingLeft: 10 }}>
          {entities.map(item => <li>{item}</li>)}
        </ol>
      </div>
    )
    return (
      yup.object().shape({
        name: yup.string().matches(nameRegex, 'Name should not contain numbers and special characters (except space)').required('Name is required'),
        gender: yup
          .string()
          .matches(alphaRegex, 'Gender should not contain numbers and special characters')
          .oneOf(['male', 'female', 'non-binary'], 'Gender should be one of [male, female, non-binary]')
          .required('Gender is required'),
        dob: yup.string().required('Date of Birth is required'),
        mobile_number: yup.string().matches(phoneRegExp, 'The mobile number must be valid and its length should be between 5 to 20 digits.').required('Mobile number is invalid'),
        email: yup.string().matches(emailRegExp, 'Invalid email'),
        date_of_appointment: yup.string(),
        dc_name_and_location: yup.string(),
        date_of_joining: yup.string(),
        employee_address: yup.string(),
        aadhaar_card_no: yup.string(),
        job_involves: yup.string(),
        other_details: yup.string(),
        entity_name: entities.length > 0 ? yup.string().oneOf(entities, entity_name_error).required(entity_name_error) : yup.string().oneOf([''], 'No entities present for your company'),
      })
    )
  },

  preEmp_bulk_uploader: ({ entities = [] }) => {
    const entity_name_error = (
      <div>
        Entity name should be one of the following:
        <ol style={{ listStyleType: 'disc', listStylePosition: 'inside', paddingLeft: 10 }}>
          {entities.map(item => <li>{item}</li>)}
        </ol>
      </div>
    )
    return (
      yup.object().shape({
        name: yup.string().matches(nameRegex, 'Name should not contain numbers and special characters (except space)').required('Name is required'),
        gender: yup
          .string()
          .matches(alphaRegex, 'Gender should not contain numbers and special characters')
          .oneOf(['male', 'female', 'non-binary'], 'Gender should be one of [male, female, non-binary]')
          .required('Gender is required'),
        dob: yup.string().required('Date of Birth is required'),
        mobile_number: yup.string().matches(phoneRegExp, 'The mobile number must be valid and its length should be between 5 to 20 digits.').required('Mobile number is invalid'),
        email: yup.string().matches(emailRegExp, 'Invalid email'),
        date_of_appointment: yup.string(),
        dc_name_and_location: yup.string(),
        date_of_joining: yup.string(),
        employee_address: yup.string(),
        aadhaar_card_no: yup.string(),
        job_involves: yup.string(),
        other_details: yup.string(),
        entity_name: entities.length > 0 ? yup.string().oneOf(entities, entity_name_error).required(entity_name_error) : yup.string().oneOf([''], 'No entities present for your company'),
      })
    )
  },

  stepathon_team_bulk_uploader: (_) => {
    return (
      yup.object().shape({
        team_name: yup.string().matches(teamNameRegex, 'Team name should not contain  special characters (except space)').required('Name is required'),
        email: yup.string().matches(emailRegExp, 'Invalid email').required('Email id is required'),
      })
    )
  },
  
  re_upload_stepathon_upload: (_) => {
    return (
      yup.object().shape({
        team_name: yup.string().matches(teamNameRegex, 'Team name should not contain special characters (except space)').required('Name is required'),
        email: yup.string().matches(emailRegExp, 'Invalid email').required('Email id is required'),
      })
    )
  },
  stepathon_member_bulk_uploader: (_) => {
    return (
      yup.object().shape({
        email: yup.string().matches(emailRegExp, 'Invalid email').required('Email id is required'),
      })
    )
  },
  
  re_upload_stepathon_member_upload: (_) => {
    return (
      yup.object().shape({
        email: yup.string().matches(emailRegExp, 'Invalid email').required('Email id is required'),
      })
    )
  },
}

export default uploadFileSchema
